<div class="toggle-container">
<div class="label" [ngClass]="!checked ? 'active' : ''">{{ firstLabel | translate}}</div>
<mat-slide-toggle
  (change)="changeToggleButton.emit($event)"
  [checked]="checked"
  [disabled]="hygieneInspectionDisabled"
></mat-slide-toggle>
  <div class="label" [ngClass]="checked ? 'active' : ''">{{ secondLabel | translate}}</div>
</div>
